// extracted by mini-css-extract-plugin
module.exports = {"footerSocialLinks":"social-medias-module--footer-social-links--3fYIR","footerSocialItem":"social-medias-module--footer-social-item--3EclY"};